import { createFeatureSelector } from '../../create-feature-selector';
import { createSelector } from 'reselect';

const loyaltyRewardsFeatureSelector = createFeatureSelector('loyaltyRewards');

export const selectLoyaltyRewardData = createSelector(loyaltyRewardsFeatureSelector, (f) => f.data);
